import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'app-color-picker',
  templateUrl: './color-picker.component.html',
  styleUrl: './color-picker.component.scss',
})
export class ColorPickerComponent implements OnChanges {
  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['value'] && changes['value'].currentValue) {
      this.value = changes['value'].currentValue;
      if (this.value === 'default') {
        this.value = '#808080';
      }
    }
  }

  @Input() id!: string;
  @Input() value: string = '#ffffff';
  @Output() valueChange = new EventEmitter<string>();
  @Output() openPicker = new EventEmitter<string>();
  @Input() showColorPicker: boolean = false;

  constructor(
    private eRef: ElementRef,
    private cdr: ChangeDetectorRef,
  ) {}

  toggleColorPicker() {
    this.showColorPicker = !this.showColorPicker;
    if (this.showColorPicker) {
      this.openPicker.emit(this.id);
    }
  }

  colorChanged(color: string) {
    this.value = color;
    this.showColorPicker = false;
    this.valueChange.emit(this.value);
    this.cdr.detectChanges();
  }
  @HostListener('document:click', ['$event'])
  @HostListener('document:focusin', ['$event'])
  handleOutsideClick(event: any) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.showColorPicker = false;
    }
  }
}
